<template>
  <div class="table-box">
    <!--快捷审核列表-->
    <bak />
    <div class>
      <!-- <project-detail-panel isQuick="1" /> -->
      <remarkHinit />
      <el-row
        type="flex"
        justify="start"
        align="middle"
        style="justify-content:space-between"
      >
        <!-- 全页全选 -->
        <div>
          <el-checkbox
            style="margin-right: 30px"
            :disabled="!tableData.length"
            @change="selectDataAll"
            :value="selectedSize > 0"
            :indeterminate="indeterminate"
          >
            结果全选
            <span v-if="selectedSize > 500" style="color: red;">
              （最多选择500条）
            </span>
          </el-checkbox>
          <span>
            已选
            <span>{{ selectedSize || 0 }}</span>
            项， 批量操作：
          </span>
          <el-button type="primary" size="small" @click="batchPass(2)">
            批量通过
          </el-button>
          <el-button
            style="margin:15px"
            type="primary"
            size="small"
            plain
            :disabled="!selectedSize"
            @click="batchPass(3)"
          >
            批量驳回
          </el-button>
        </div>
        <div style="float:right">
          <el-button type="primary" @click="showCheckLog" size="small">
            审核记录
          </el-button>
          <el-button type="primary" @click="quickReview" size="small">
            设置展示信息
          </el-button>
        </div>
      </el-row>
      <!-- 查询结果包含 重复图片的话 展示-->
      <el-row v-if="hasRepeatPic" style="padding-bottom: 5px">
        <el-col :span="24">
          <span>
            <i class="el-icon-warning" style="color: #ff4949"></i>
            <span style="font-weight: 500">图片查重提示：</span>
            <span style="color: #ff4949">*</span>
            标记任务记录内提交的图存在重复，请注意查看
          </span>
        </el-col>
      </el-row>
      <el-table
        v-loading="loading"
        height="75vh"
        :data="tableData"
        :row-style="tableRowStyle"
        class="v2-base-table"
        style="width: 100%"
        ref="multipleTable"
      >
        <el-table-column :resizable="false" width="35" fixed="left">
          <template slot="header" slot-scope="scope">
            <!-- 单页全选 -->
            <el-checkbox
              style="margin-right: 30px"
              :disabled="headerCheckBoxDisabled"
              :indeterminate="isIndeterminate"
              :value="headerSelectSize === tableData.length"
              @change="selectAll"
            />
          </template>
          <template slot-scope="scope">
            <!-- 单个选取 -->
            <checkBoxRender
              :row="scope.row"
              :selectedSize="selectedSize"
              @selectCell="selectCell"
            />
          </template>
        </el-table-column>
        <el-table-column
          fixed
          :resizable="false"
          label="序号"
          width="70"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <!-- <img
                v-if="+scope.row.isPicRepeat"
                style="width: 20px; height: 20px; cursor: pointer"
                @click="showRepeatPicture(scope.row)"
                :src="require('@/assets/重复报警.png')"
                alt=""
              /> -->
              <img
                v-if="isHasRepeatPic(scope.row)"
                style="width: 20px; height: 20px; cursor: pointer"
                @click="newRepeatPickure(scope.row)"
                :src="require('@/assets/重复报警.png')"
                alt=""
              />

              <span style="color:#909399">{{ scope.$index + 1 }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- //患者调研来源 -->
        <el-table-column
          v-for="(item, index) in listHeader"
          :key="index"
          :resizable="false"
          align="center"
          :min-width="item.topicType == 30 ? '400' : '200'"
        >
          <!-- 1：文本 2：时间 3：选择(不带value选择题) 4：图片地址 5：html地址 6：月度 7 :带value选择题 -->
          <template slot="header" slot-scope="scope">
            <!-- <div>{{ item.label }}</div> -->
            <el-tooltip
              :disabled="
                !titleTooltip.includes(`custom-header-cell-title${index}`)
              "
              effect="dark"
              :content="item.label"
              placement="top"
            >
              <div
                :class="[
                  'custom-header-cell-title',
                  `custom-header-cell-title${index}`,
                  titleTooltip.includes(`custom-header-cell-title${index}`)
                    ? 'custom-header-cell-title-css'
                    : ''
                ]"
              >
                {{ item.label }}
              </div>
            </el-tooltip>

            <!-- 文本，定位，图片题型 -->
            <el-input
              placeholder="请输入内容"
              v-model="item.conditionKey"
              v-if="
                [1, 4, 5, 9].includes(item.dataType) &&
                  ![30].includes(item.topicType) &&
                  !(
                    item.prop == 'customerName' &&
                    item.dataType == 1 &&
                    [5, 20].includes(projectDetail.projectType)
                  )
              "
              :disabled="item.disable === 1"
            ></el-input>
            <!-- dataType:8 数字填空题 为区间 -->
            <div style="display: inline-block;" v-else-if="item.dataType === 8">
              <el-input
                style="width: 73px;"
                placeholder="请输入内容"
                v-model="item.conditionKey[0]"
                :disabled="item.disable === 1"
                @focus="
                  item.conditionKey = Array.isArray(item.conditionKey)
                    ? item.conditionKey
                    : ['', '']
                "
                @input="
                  e => {
                    item.conditionKey[0] = limitToNum(e);
                  }
                "
              ></el-input>
              <span style="font-size:10px;margin:0 5px;">—</span>
              <el-input
                style="width: 73px;"
                placeholder="请输入内容"
                v-model="item.conditionKey[1]"
                :disabled="item.disable === 1"
                @focus="
                  item.conditionKey = Array.isArray(item.conditionKey)
                    ? item.conditionKey
                    : ['', '']
                "
                @input="
                  e => {
                    item.conditionKey[1] = limitToNum(e);
                  }
                "
              ></el-input>
            </div>
            <!-- 时间日期选择题 -->
            <el-date-picker
              v-else-if="item.dataType === 2"
              type="daterange"
              v-model="item.conditionKey"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <!-- 月度选择题 -->
            <el-date-picker
              v-else-if="item.dataType === 6"
              v-model="item.conditionKey"
              type="monthrange"
              value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            ></el-date-picker>
            <!-- 选择题 -->
            <el-select
              placeholder="请选择"
              clearable
              filterable
              collapse-tags
              v-model="item.conditionKey"
              v-else-if="[3, 7].includes(item.dataType)"
            >
              <el-option
                v-for="citem in item.options"
                :key="citem.value"
                :label="citem.label ? citem.label : citem"
                :value="citem.value ? citem.value : citem"
              >
                <el-tooltip
                  v-if="(citem.label ? citem.label : citem).length > 30"
                  placement="top"
                  effect="dark"
                  :content="citem.label ? citem.label : citem"
                >
                  <p>
                    {{ (citem.label ? citem.label : citem).slice(0, 30) }}...
                  </p>
                </el-tooltip>
                <p v-else>{{ citem.label ? citem.label : citem }}</p>
              </el-option>
            </el-select>
            <!-- 人员标签 -->
            <el-autocomplete
              v-if="item.dataType == 31"
              placeholder="人员标签"
              :maxlength="30"
              v-model="item.conditionKey"
              :fetch-suggestions="
                (queryString, cb) => {
                  cb(
                    [{ value: '未设置' }].filter(
                      i => !queryString || i.value.indexOf(queryString) > -1
                    )
                  );
                }
              "
              @select="
                item => {
                  item.conditionKey = item.value;
                }
              "
            ></el-autocomplete>
            <!-- //患者调研来源和可配置的目标题 -->
            <div
              v-if="
                [30].includes(item.topicType) ||
                  (item.prop == 'customerName' &&
                    item.dataType == 1 &&
                    [5, 20].includes(projectDetail.projectType))
              "
              class="patient-source"
            >
              <div style="margin-right: 10px;">
                <el-select
                  style="width: 100px;"
                  placeholder="请选择"
                  clearable
                  v-model="item.conditionKey1"
                >
                  <el-option
                    v-for="citem in cleanConditionOptions"
                    :key="citem.value"
                    :label="citem.label"
                    :value="citem.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                v-if="projectDetail.projectType == 5"
                style="margin-right: 10px;"
              >
                <el-select
                  placeholder="请选择"
                  clearable
                  v-model="item.conditionKey2"
                >
                  <el-option
                    v-for="citem in item.options"
                    :key="citem.value"
                    :label="citem.label ? citem.label : citem"
                    :value="citem.value ? citem.value : citem"
                  ></el-option>
                </el-select>
              </div>
              <div style="">
                <el-input
                  placeholder="请输入内容"
                  v-model="item.conditionKey3"
                  clearable
                ></el-input>
              </div>
            </div>
            <!-- //备注： -->
            <template v-if="item.remark">
              <el-tooltip
                :disabled="
                  !remarkTooltip.includes(`custom-header-cell-remark${index}`)
                "
                effect="dark"
                :content="item.remark"
                placement="top"
              >
                <div
                  style="text-align: left;color:#F56C6C;"
                  :class="[
                    'custom-header-cell-remark',
                    `custom-header-cell-remark${index}`,
                    remarkTooltip.includes(`custom-header-cell-remark${index}`)
                      ? 'custom-header-cell-remark-css'
                      : ''
                  ]"
                >
                  备注：
                  <span>
                    {{ item.remark }}
                  </span>
                </div>
              </el-tooltip>
            </template>
          </template>
          <template slot-scope="scope">
            <!-- 可放大图片【图片/定位 题型】 -->
            <span
              style="display: flex;justify-content: space-around"
              v-if="[4, 9].includes(item.dataType) && item.topicType !== 29"
            >
              <span v-if="!scope.row[item.prop]">-</span>
              <span
                v-else
                style="margin: 5px;"
                v-for="(citem, index) in imgList(scope.row[item.prop])"
                :key="index"
              >
                <div style="display:flex">
                  <el-image
                    style="width:100px;height:50px"
                    :src="citem"
                    :preview-src-list="imgList(scope.row[item.prop])"
                    @click="onClickImageMask"
                  ></el-image>
                  <el-button
                    v-if="item.dataType === 9"
                    @click="onDiffMap(scope.row)"
                    type="text"
                  >
                    对比
                    <br />
                    地图
                  </el-button>
                  <el-button
                    v-if="item.dataType === 9 || item.topicType === 16"
                    style="margin-left:10px;color:#0B6623"
                    @click="mapRefresh(scope.row, item.prop)"
                    type="text"
                  >
                    更新
                    <br />
                    地图
                  </el-button>
                </div>
              </span>
            </span>
            <span v-else-if="item.dataType === 7">
              {{ setOptions(item.options, scope.row[item.prop]) }}
            </span>
            <!-- money -->
            <span v-else-if="item.prop === 'finishSumTaskPrice'">
              {{ scope.row[item.prop] | money }}
            </span>
            <!-- //患者调研来源 -->
            <!-- cleanFlagHighlight 0-不显示 1-高亮 2-灰掉(不高亮) -->
            <span
              v-else-if="
                [30].includes(item.topicType) ||
                  (item.prop == 'customerName' && item.dataType == 1)
              "
            >
              <span
                style="text-align: left;"
                v-if="
                  scope.row['cleanFlagHighlight'] &&
                    scope.row['cleanFlagHighlight'] !== 0
                "
              >
                <img
                  style="width: 20px; height: 20px;margin-bottom: 4px;"
                  :src="
                    scope.row['cleanFlagHighlight'] == 1
                      ? require('@/assets/gantanhao@2x.png')
                      : require('@/assets/gantanhaohui@2x.png')
                  "
                  alt=""
                />
              </span>
              <span v-if="item.prop == 'customerName' && item.dataType == 1">
                {{ scope.row[item.prop] }}
              </span>
              <span v-else>
                {{ JSON.parse(scope.row[item.prop]).fullName }}
              </span>
              <!-- {{ scope.row[item.prop] || '-' }} -->
              <!-- {{
                `${JSON.parse(scope.row[item.prop]).name}/${
                  JSON.parse(scope.row[item.prop]).provinceName
                }${JSON.parse(scope.row[item.prop]).cityName}${
                  JSON.parse(scope.row[item.prop]).districtName
                }/${JSON.parse(scope.row[item.prop]).address}`
              }} -->
            </span>
            <!-- money -->
            <span v-else-if="item.prop === 'userTag'">
              {{ scope.row[item.prop] || '未设置' }}
            </span>
            <!-- 文本题型 -->
            <span :style="setAuditProgress(scope.row, item.prop)" v-else>
              {{ scope.row[item.prop] || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          fixed="right"
          align="center"
          width="220"
        >
          <template slot="header">
            <span>操作</span>
            <div>
              <el-button @click="search(true, true)" type="text">
                搜索
              </el-button>
              <el-button @click="reset" type="text">重置</el-button>
            </div>
          </template>
          <template slot-scope="scope">
            <el-button type="text" @click="showDetail(scope)">
              查看
            </el-button>
            <el-button
              type="text"
              :disabled="scope.row.passButtonDisable == 1"
              @click="pass(2, scope.row)"
            >
              通过
            </el-button>
            <el-button type="text" @click="pass(3, scope.row)">
              不通过
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNo"
        :total="totalElements"
        :page-sizes="[15, 60, 100]"
        :page-size="paginationData.pageSize"
        layout="total, prev, sizes, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
const feedback = require('../../imgs/feedback.png');
const forward = require('../../imgs/forward.png');
import remarkHinit from '../../components/remark-hinit.vue';
import createExtend from '@C/createExtend';
import { pageInation } from '@/Mixin/listMixin';
import bak from '../../components/bak.vue';
import quickReview from '@/page/project-record/views/task-record/task-quick-review';
// import ProjectDetailPanel from './project-detail';
import Vue from 'vue';
import request from '@/tools/request';
import repeatPicture from './repeat-pickure-table.vue';
import newRepeatPickure from './new-repeat-pickure-table.vue';
import DiffMap from '@/page/project-record/components/diff-map';

import { mapState, mapMutations } from 'vuex';
import openDetail from '../../services/open-detail';
import auditRow from '../../services/audit-row';
import { quickAudit, Task } from '../../api';
import initProject from '../../mixins/sync-project';

const MAX_SELECTED = 2000; // 最大勾选值

export default {
  name: 'quickExamineTable',
  mixins: [pageInation, initProject],
  data() {
    // const quickCheckedList = JSON.parse(
    //   sessionStorage.getItem('quickCheckedList')
    // );

    return {
      //患者调研来源
      cleanConditionOptions: [
        { label: '来源', value: '来源' },
        { label: '系统库', value: '系统库' },
        { label: '用户新增', value: '用户新增' }
      ],
      titleTooltip: [],
      remarkTooltip: [],
      getList: quickAudit.getDisplayInfoList, // 获取列表的AJAX
      selectedSize: 0,
      searchQuery: {
        conditions: [],
        isSelected: '0',
        projectId: this.$route.query.projectId
      },
      paginationData: {
        pageSize: 60
      },
      // listHeader: quickCheckedList,
      listHeader: [],
      headerCheckBoxDisabled: true,
      highLightItem: '', //已经查看过的任务id
      newRepeatList: {},
      queryCountTimer: null
    };
  },
  computed: {
    ...mapState('dataAnalysis', ['projectDetail']),
    hasRepeatPic() {
      // 当前是否有重复图片
      return Object.keys(this.newRepeatList).length > 0;
    },
    isIndeterminate() {
      return (
        this.headerSelectSize > 0 &&
        this.headerSelectSize < this.tableData.length
      );
    },
    indeterminate() {
      return this.selectedSize > 0 && this.selectedSize < this.totalElements;
    },
    headerSelectSize() {
      const size = this.tableData.filter(item => {
        return +item.isSelected == '1';
      });
      return size.length;
    }
  },
  watch: {
    tableData() {
      // 防止列表错行
      this.$refs.multipleTable.doLayout();
      this.setHeaderCheckBoxStatus();
    },
    selectedSize: {
      handler(v) {
        this.setHeaderCheckBoxStatus();
        this.searchQuery.isSelected = v > 0 ? '1' : '0';
      }
    }
  },
  components: {
    remarkHinit,
    bak,
    // ProjectDetailPanel,
    checkBoxRender: {
      props: {
        row: Object,
        selectedSize: {
          type: Number,
          defalult: 0
        }
      },
      render(h) {
        const _this = this;
        Vue.util.defineReactive(_this.row, 'isSelected');
        return h('el-checkbox', {
          props: {
            value: _this.row.isSelected == '1',
            disabled:
              _this.selectedSize >= MAX_SELECTED && _this.row.isSelected == '0'
          },
          on: {
            input: function(v) {
              _this.row.isSelected = v ? '1' : '0';
              _this.$emit('selectCell', v, _this.row);
            }
          }
        });
      }
    }
  },
  methods: {
    ...mapMutations(['SET_PAGENUM']),
    // 点击遮罩层时关闭
    onClickImageMask() {
      this.$nextTick(() => {
        let domImageMask = document.querySelector('.el-image-viewer__mask');
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', () => {
          document.querySelector('.el-image-viewer__close').click();
        });
      });
    },
    mapRefresh(row, prop) {
      Task.replaceMap({
        projectId: this.projectDetail.projectId,
        taskId: row.id
      }).then(res => {
        row[prop] = res.pdata;
        this.$message.success('操作成功');
      });
    },
    // 获取列表完毕
    async getListFinished() {
      // 查询是否 存在有重复图片
      this.$nextTick(() => {
        this.findRepeatImg();
      });
    },
    tableRowStyle({ row }) {
      if (this.highLightItem === row.id) {
        return {
          'background-color': '#fffaf1'
        };
      }
      return '';
    },
    isHasRepeatPic(row) {
      const hasRepeatPicIds = Object.keys(this.newRepeatList);
      const isHasRepeatPic = hasRepeatPicIds.includes(String(row.id));
      return isHasRepeatPic;
    },
    findRepeatImg() {
      const ids = this.tableData
        .map(item => {
          return item.id;
        })
        .join(',');
      if (ids.length > 0) {
        Task.findSimiForList({
          ids,
          projectId: this.$route.query.projectId
        }).then(({ pdata }) => {
          this.newRepeatList = pdata;
        });
      }
    },
    limitToNum(data) {
      let num = data
        .replace(/[^\d.-]/g, '')
        //只允许一个小数点
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        //只能输入小数点后两位
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');
      return num;
    },
    searchRule(list) {
      let ruleError = list.find(item => {
        if (+item.dataType === 8 && Array.isArray(item.conditionKey)) {
          //因为区间搜索需要全部填或者全部不填
          //所以判断第一个字段没有值并且第二个字段有值返回 error
          if (!item.conditionKey[0] && item.conditionKey[1]) {
            this.$message.error('请填写正确的数字区间');
            return item;
          } else if (!item.conditionKey[1] && item.conditionKey[0]) {
            this.$message.error('请填写正确的数字区间');
            return item;
          } else if (
            isNaN(+item.conditionKey[0]) ||
            isNaN(+item.conditionKey[1])
          ) {
            this.$message.error('请填写正确的数字区间');
            return item;
          } else if (+item.conditionKey[0] > +item.conditionKey[1]) {
            this.$message.error('请填写正确的数字区间');
            return item;
          }
        }
      });
      if (ruleError) {
        return false;
      } else {
        return true;
      }
    },
    onDiffMap(row) {
      createExtend(DiffMap, {
        projectId: this.projectDetail.projectId,
        row: {
          ...row,
          taskId: row.id
        }
      });
    },
    showRepeatPicture(row) {
      createExtend(repeatPicture, {
        projectId: this.projectDetail.projectId,
        sceneType: this.projectDetail.projectType,
        currentTaskId: row.id,
        isOpenedByOther: !!+this.$route.query.isOpenedByOther
      }).$on('parentRefresh', () => {
        this.search();
      });
    },
    newRepeatPickure(row) {
      createExtend(newRepeatPickure, {
        projectId: this.projectDetail.projectId,
        taskId: row.id,
        isOpenedByOther: this.isOpenedByOther
      }).$on('parentRefresh', () => {
        this.search();
      });
    },
    // 设置当页全选状态，如果当页没有勾选数据，则禁用。根据class判断，防止下一页溢出可进行当页全选
    setHeaderCheckBoxStatus() {
      this.$nextTick(() => {
        // >= 2000 && 没有勾选数据，则禁止操作。否则表示当页已全部勾选或者小于2000
        if (
          this.selectedSize + (this.tableData.length - this.headerSelectSize) >
            MAX_SELECTED || // 最多2000条
          !this.tableData.length
        ) {
          this.headerCheckBoxDisabled = true;
        } else {
          this.headerCheckBoxDisabled = false;
        }
      });
    },
    setAuditProgress(row, prop) {
      try {
        const auditProgressList = row.auditProgress.split('/');
        if (
          prop === 'auditProgress' &&
          +auditProgressList[0] >= +auditProgressList[1]
        ) {
          return 'color:red';
        } else if (prop === 'auditProgress') {
          return 'color:#67c23a';
        }
      } catch (e) {
        return;
      }
    },
    async pass(auditStatus, row) {
      auditRow({
        ajax: quickAudit.auditStatus,
        params: {
          auditStatus,
          taskId: row.id,
          projectId: this.searchQuery.projectId
        },
        getList: () => this.search(1),
        auditStatus,
        cleanAllSelectedAjax: quickAudit.selectAllRecord
      });
    },
    //是否评率过快
    async isFrequencyFast() {
      let countdown = 0; // 倒计时初始值
      let timer = null; // 存储定时器的引用
      let setTime = null;
      let currentTime = Math.ceil(Date.now() / 1000);
      const randomSecond = Math.floor(Math.random() * 21) + 10;
      let lastTime = '';
      let res = await quickAudit.batchAuditCountDown();
      lastTime = Math.ceil(res.data.data / 1000);
      let intervalTime = currentTime - lastTime; //间隔时间
      let selcetTime = this.selectedSize;
      if (intervalTime < selcetTime) {
        countdown = selcetTime - intervalTime;
        if (this.selectedSize >= 500) {
          countdown = countdown + randomSecond;
        }
      } else {
        countdown = null;
      }
      if (countdown && countdown > 0) {
        //计算时间
        return new Promise(resolve => {
          this.$confirm(
            `<p>是否确认通过<span style="color:#027cfa">${
              this.selectedSize
            }</span>条任务记录，请谨慎操作</p><p style="font-size:12px;color:red;margin-top:20px"><img style="width:30px;height:30px;margin-top:-16px" src="${require('../../../../assets/img/休息.svg')}" />提示：您的审核频率过快，请保持劳逸结合审核效果才会更高哦！</p>`,
            '',
            {
              confirmButtonText: `确定(${countdown}s)`, // 初始按钮文本
              cancelButtonText: '取消',
              customClass: 'customRateDialog',
              dangerouslyUseHTMLString: true,
              showClose: false,
              closeOnPressEscape: false,
              closeOnClickModal: false
            }
          )
            .then(() => {
              resolve();
              clearInterval(timer);
              clearTimeout(setTime);
              restBtn();
            })
            .catch(() => {
              clearInterval(timer);
              clearTimeout(setTime);
              try {
                const btn = document.querySelector('.daojishi_btn.is-disabled');
                btn.disabled = false;
                btn.classList.remove('is-disabled');
                btn.classList.remove('daojishi_btn');
              } catch (error) {
                console.log(error);
              }
              restBtn();
            });
          let btnWrapper = null;
          setTime = setTimeout(() => {
            btnWrapper = document.querySelector(
              '.customRateDialog .el-message-box__btns .el-button--primary'
            );
            btnWrapper.disabled = true;
            btnWrapper.classList.add('is-disabled');
            btnWrapper.classList.add('daojishi_btn');
          }, 100);
          let startCountdown = () => {
            timer = setInterval(() => {
              let parentElement = document.querySelector(
                '.customRateDialog > .el-message-box__btns'
              ).lastChild;
              let lastSpan = parentElement.querySelector('span');
              lastSpan.innerHTML = `确定(${countdown}s)`;
              if (countdown > 0) {
                countdown--;
              } else {
                lastSpan.innerHTML = '确定';
                clearInterval(timer);
                if (btnWrapper) {
                  btnWrapper.disabled = false;
                  btnWrapper.classList.remove('is-disabled');
                  btnWrapper.classList.remove('daojishi_btn');
                }
              }
            }, 1000);
          };
          startCountdown();
          let restBtn = () => {
            let parentElement = document.querySelector(
              '.customRateDialog > .el-message-box__btns'
            ).lastChild;
            let lastSpan = parentElement.querySelector('span');
            lastSpan.innerHTML = '确定';
            document.querySelector('.customRateDialog').parentNode.remove();
          };
        });
      }
    },

    async batchPass(auditStatus) {
      await this.isFrequencyFast();
      const query = {
        auditStatus,
        projectId: this.searchQuery.projectId
      };
      let loading;
      try {
        auditRow({
          ajax: quickAudit.batchAudit,
          params: query,
          auditStatus,
          beforeGetList: () => {
            // 展示 loading
            loading = this.$loading({
              lock: true,
              text: `0 / ${this.selectedSize}`,
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.queryCountTimer && clearInterval(this.queryCountTimer);
            // 轮询进度
            this.queryCountTimer = setInterval(async () => {
              const projectId = this.$store.state.dataAnalysis.projectDetail
                .projectId;
              if (projectId) {
                try {
                  const {
                    data: { data }
                  } = await request.post(
                    '/rest/cso/saas/taskRecord/auditOssStatus/all/queryCount',
                    {
                      projectId: projectId,
                      source: 1 //1任务记录 2 快捷审核
                    }
                  );
                  loading.setText(`${data} / ${this.selectedSize}`);
                } catch (error) {
                  this.queryCountTimer && clearInterval(this.queryCountTimer);
                  loading.close();
                }
              }
            }, 500);
          },
          getList: () => this.search(1),
          afterGetList: () => {
            if (!loading) return;
            loading.setText(`${this.selectedSize} / ${this.selectedSize}`);
            clearInterval(this.queryCountTimer);
            loading.close();
          },
          auditLength: this.selectedSize,
          cleanAllSelectedAjax: quickAudit.selectAllRecord
        });
      } catch (err) {
        return;
      }
    },
    editImg(key) {
      const target = key === 'feedback' ? feedback : forward;
      return target;
    },
    showCheckLog() {
      this.$router.push({
        name: 'taskCheckLog',
        query: {
          projectId: this.searchQuery.projectId,
          type: this.$route.query.type
        }
      });
    },
    quickReview() {
      createExtend(quickReview, {
        projectId: this.searchQuery.projectId,
        firstEnter: 0
      }).$on('refresh', () => {
        // this.listHeader = JSON.parse(
        //   sessionStorage.getItem('quickCheckedList')
        // );
        this.setListHeader();
        this.search();
      });
    },
    //图片类型题url分割
    imgList(url) {
      const newUrl = url;
      try {
        return newUrl.split(',');
      } catch (error) {
        return [newUrl];
      }
    },
    //带value的选择题导入options字典
    setOptions(options, prop) {
      const cell = options.filter(item => {
        return +item.value === +prop;
      });
      return cell[0].label;
    },
    //查看详情
    showDetail({ row }) {
      this.highLightItem = row.id; //点击了该项的查看则把任务id替换【仅代表用户当前查看的任务】
      openDetail({
        auditApi: quickAudit.audit,
        auditCleanAllSelectedAjax: quickAudit.selectAllRecord,
        auditOptions: {
          conditions: this.searchQuery.conditions,
          ...this.searchQuery,
          id: row.id
        },
        row,
        tableSearchQuery: this.searchQuery,
        projectDetail: this.$store.state.dataAnalysis.projectDetail,
        getList: this.saveSuccess
      });
    },
    //重置，绑定数据清空
    reset() {
      this.listHeader.forEach(item => {
        if (
          [29, 30].includes(item.topicType) ||
          (item.prop == 'customerName' && item.dataType == 1)
        ) {
          item.conditionKey = '';
          item.conditionKey1 = '来源';
          item.conditionKey2 = '全部';
          item.conditionKey3 = '';
        }
        item.conditionKey = '';
      });
    },
    //全页全选
    selectDataAll() {
      let isSelected = this.selectedSize > 0 ? false : true;
      isSelected = this.indeterminate ? true : isSelected;
      this.searchQuery.isSelected = isSelected ? '1' : '0';
      quickAudit.selectAllRecord(this.searchQuery).then(res => {
        this.selectedSize = res.data.data;
        this.search();
      });
    },
    //当页全选
    selectAll(e) {
      if (this.selectedSize === 0) {
        this.searchQuery.isSelected = e ? '1' : '0';
      }
      const selectList = this.tableData.map(item => {
        return item.id;
      });
      quickAudit
        .selectRecord({
          taskIds: selectList,
          isDelete: e ? '0' : '1',
          projectId: this.$route.query.projectId
        })
        .then(res => {
          this.selectedSize = res.data.data;
          this.search();
        });
    },
    //单选
    selectCell(e, row) {
      quickAudit
        .selectRecord({
          taskIds: [row.id],
          isDelete: e ? '0' : '1',
          projectId: this.$route.query.projectId
        })
        .then(res => {
          this.selectedSize = res.data.data;
          this.tableData = JSON.parse(JSON.stringify(this.tableData));
        });
    },
    search(next, isSerch) {
      if (next) {
        this.searchQuery.isSelected = 0;
        this.selectedSize = 0;
      }
      //数字区间校验
      if (!this.searchRule(this.listHeader)) {
        return;
      }
      // 区分是否是点击搜索
      // 只有点击搜索才会重新配置搜索项，否则数据写入时机有问题
      if (isSerch) {
        this.setConditions();
      }
      this.initWatchRouteChange(this.paginationData.pageNo);
    },
    setListHeader() {
      let quickCheckedList = [];
      try {
        quickCheckedList = JSON.parse(
          sessionStorage.getItem('quickCheckedList')
        );
      } catch (e) {
        console.error(e);
        this.$sentry.captureMessage('审核-setListHeader', 'error');
      }
      this.listHeader = quickCheckedList;
      //患者调研来源
      this.listHeader.forEach(item => {
        if (
          item.topicType == 30 ||
          (item.prop == 'customerName' &&
            item.dataType == 1 &&
            [5, 20].includes(this.projectDetail.projectType))
        ) {
          if (!this.cleanConditionOptions.find(opt => opt.value === '来源')) {
            console.error('默认值不在 cleanConditionOptions 中');
          }
          this.$set(item, 'conditionKey1', '来源');
          this.$set(item, 'conditionKey2', '全部');
          this.$set(item, 'conditionKey3', '');
        }
      });
    },

    setConditions() {
      this.searchQuery.notSet = 0;
      this.searchQuery.conditions = this.listHeader.map(item => {
        //将区间搜素里的array转化成string如果为['','']则转化为''
        let dataValue = item.conditionKey;
        if (Array.isArray(dataValue)) {
          dataValue = dataValue.join(',');
        }
        //患者调研来源
        if (
          item.topicType == 30 ||
          (item.prop == 'customerName' &&
            item.dataType == 1 &&
            [5, 20].includes(this.projectDetail.projectType))
        ) {
          let params = {
            type: item.conditionKey1,
            source: item.conditionKey2,
            name: item.conditionKey3
          };
          if (this.projectDetail.projectType !== 5) {
            delete params.source;
          }
          dataValue = JSON.stringify(params);
        }
        dataValue = dataValue === ',' ? '' : dataValue;
        //金额搜索时转化
        if (item.prop === 'finishSumTaskPrice') {
          dataValue = +dataValue * 100;
        }
        //人员标签搜索有未设置选项
        if (item.prop === 'userTag' && item.conditionKey.includes('未设置')) {
          this.searchQuery.notSet = 1;
        }
        return {
          key: item.prop,
          value: dataValue || '',
          isTopic: item.isTopic,
          topicType: item.topicType
        };
      });

      //志宏说可配置的目标题帮他拆分一下数据然后在组装数据
      if (this.projectDetail.projectType == 20) {
        let targetValueIndex = this.searchQuery.conditions.findIndex(
          item => item.key === 'customerName'
        );
        let targetValue = this.searchQuery.conditions.find(
          item => item.key === 'customerName'
        );
        if (targetValue) {
          this.searchQuery.conditions.splice(targetValueIndex, 1);
          let targetParam = Object.keys(JSON.parse(targetValue.value)).reduce(
            (pr, cur) => {
              pr.push({
                ...targetValue,
                key: cur == 'name' ? 'customerName' : 'sourceType',
                value: JSON.parse(targetValue.value)[cur]
              });
              return pr;
            },
            []
          );
          this.searchQuery.conditions.unshift(...targetParam);
        }
      }
    },
    getTableFieldStyle() {
      setTimeout(() => {
        let customHeaderCellTitleDom = '';
        let customHeaderCellRemarkDom = '';
        let remarkSetArr = new Set();
        let titleSetArr = new Set();

        customHeaderCellTitleDom = document.querySelectorAll(
          '.custom-header-cell-title'
        );
        customHeaderCellRemarkDom = document.querySelectorAll(
          '.custom-header-cell-remark'
        );
        customHeaderCellTitleDom.forEach(itemDom => {
          if (itemDom.offsetHeight > 46) {
            titleSetArr.add(itemDom.classList[2]);
          }
        });
        customHeaderCellRemarkDom.forEach(itemDom => {
          if (itemDom.offsetHeight > 23) {
            remarkSetArr.add(itemDom.classList[2]);
          }
        });
        this.remarkTooltip = [...remarkSetArr];
        this.titleTooltip = [...titleSetArr];
      }, 100);
    }
  },
  created() {
    this.setListHeader();
    this.setConditions();
  },
  mounted() {
    //解决放大缩小页面时表格错位问题
    const _this = this;
    window.onresize = () => {
      _this.$nextTick(() => {
        _this.$refs.multipleTable && _this.$refs.multipleTable.doLayout();
      });
    };
    this.getTableFieldStyle();
  },
  destroyed() {
    if (this.queryCountTimer) {
      clearInterval(this.queryCountTimer);
      this.queryCountTimer = null;
    }
    this.SET_PAGENUM(1);
  }
};
</script>
<style lang="scss" scoped>
::v-deep.el-table * {
  font-size: 13px !important;
}
::v-deep.table-box .el-table__header th.is-leaf:nth-last-child(2) {
  z-index: 0 !important;
}
::v-deep.table-box .el-table__header th.is-leaf:nth-last-child(1) {
  border: 1px solid #a3d0fd;
}
::v-deep.table-box .el-table__body td:nth-last-child(1) {
  border-left: 1px solid #ebeef5;
}
>>> .el-date-editor--daterange.el-input__inner {
  width: auto;
}
::v-deep .el-table__header-wrapper .el-input__inner {
  border: 1px solid #afc5fb !important;
}
::v-deep .el-range-separator {
  width: auto !important;
}
.custom-header-cell-title-css {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-header-cell-remark-css {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.patient-source {
  display: flex;
  align-items: center;
}
</style>
